export default class ScreenshotOverlay {
    static autoHideTimeout = 20000;
    static visibleClassName = 'visible';
    static parentClassName = 'screenshots__tab-right';
    static buttonClassName = 'screenshots__overlay-button';
    static closeClassName = 'screenshots__overlay-close';

    /**
     * @param {string} screenshot - Screenshot ID.
     * @param {function} onClick - Button callback.
     * */
    constructor(screenshot, onClick = null) {
        this.screenshot = screenshot;
        this.onClick = onClick;

        this.text = '<b>Well done!</b> Start free trial to try this feature for real!';
        this.buttonText = 'Start a <i>free trial</i>';
        this.buttonColor = 'green';

        this.hideTimeout = null;
    }

    init() {
        this.overlay = this.create();
        $(`#${this.screenshot}`)
            .parent(`.${ScreenshotOverlay.parentClassName}`)
            .append(this.overlay);
        this.button = this.overlay.find(`.${ScreenshotOverlay.buttonClassName}`);
        this.closeButton = this.overlay.find(`.${ScreenshotOverlay.closeClassName}`);

        this.overlay.on('click', (event) => {
            event.stopPropagation();
            if ($(event.target).is(this.overlay)) {
                this.hide();
            }
        });

        this.closeButton.on('click', () => {
            this.hide();
        });

        this.button.on('click', () => {
            clearTimeout(this.hideTimeout);
        });
        this.button.on('click', this.onClick);

        WG.init();

        return this;
    }

    create() {
        return $('<div />', {
            class: 'screenshots__overlay',
            html: `
                <div class="screenshots__overlay-panel">
                    <div class="screenshots__overlay-panel-left">
                        ${this.text}
                    </div>
                    <div class="screenshots__overlay-panel-right">
                        <button class="screenshots__overlay-button wg-btn wg-btn--${this.buttonColor}">
                            ${this.buttonText}
                        </button>
                        <button class="screenshots__overlay-close" type="button" title="Close"></button>
                    </div>
                </div>
            `
        });
    }

    show() {
        this.overlay.addClass(ScreenshotOverlay.visibleClassName);
        this.hideTimeout = setTimeout(() => {
            this.hide();
        }, ScreenshotOverlay.autoHideTimeout);
        return this;
    }

    hide() {
        this.overlay.removeClass(ScreenshotOverlay.visibleClassName);
        return this;
    }
}



// WEBPACK FOOTER //
// ./assets/js/projects/home-enterprise/screenshots/screenshot-overlay.js